<div class="hx-connection-quality__bars" aria-hidden="true">
  @for (bar of bars; track bar) {
    <div
      class="hx-connection-quality__bar"
      [class.hx-connection-quality__bar--active]="isBarActive(bar)"
      [attr.data-bar]="bar"></div>
  }
</div>

@if (showLabel()) {
  <span class="hx-connection-quality__label">{{ meta().label }}</span>
}
